// extracted by mini-css-extract-plugin
module.exports = {"venuePageWrapper":"venuePage_venuePageWrapper__jmhge","spaceOnBottom":"venuePage_spaceOnBottom__S9gmG"};